import { render } from "./ForgeCardSteps.vue?vue&type=template&id=0ea313f8&scoped=true&ts=true"
import script from "./ForgeCardSteps.vue?vue&type=script&lang=ts"
export * from "./ForgeCardSteps.vue?vue&type=script&lang=ts"

import "./ForgeCardSteps.vue?vue&type=style&index=0&id=0ea313f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea313f8"]])

export default __exports__